import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import SpinnerOverlay from '../../../components/SpinnerOverlay/SpinnerOverlay'

export default () => {
  const location = useLocation()
  let redirectUrl = location?.state?.redirectUrl
  let errorMessage = location?.state?.errorMessage

  if (!redirectUrl) {
    redirectUrl = new URL(window.location.href).searchParams.get('redirectUrl') ?? '/'
  }

  if (!errorMessage) {
    errorMessage = new URL(window.location.href).searchParams.get('errorMessage') ?? ''
  }

  const redirect = (url) => {
    const fullPath = url.startsWith('/') ? url : `/${url}`
    window.location.href = fullPath ?? '/'
  }

  useEffect(() => {
    if (errorMessage) {
      setTimeout(() => {
        redirect(redirectUrl)
      }, 5000)
    } else {
      redirect(redirectUrl)
    }
  }, [errorMessage, redirectUrl])

  return errorMessage ? (
    <div id="login-view">
      <div className="login-container">
        <div className="alert alert-danger">
          {`${__.trans(errorMessage)}`}
          <br />
          <br />
          {redirectUrl.includes('1177.se')
            ? __.trans('user.automatic-redirect-1177')
            : __.trans('user.automatic-logout')}
        </div>
      </div>
    </div>
  ) : (
    <SpinnerOverlay visible />
  )
}
